import { useEffect, useState } from "react";
import FormYearMonth from '../components/form-year-month';
import Header from "../components/header";
import InteractionModel, { InteractionAuthor } from "../data/InteractionModel";
import { GraduationModel, SignupModelHelper } from "../data/SignupModel";
import { months } from '../data/months';
import AmarelinhoService from '../services/AmarelinhoService';
import { AmplitudeService } from '../services/AmplitudeService';

export default function EscolaridadeInicio(props: any) {

  const [interactions, setInteractions] = useState<InteractionModel[]>([]);
  const [graduation, setGraduation] = useState<GraduationModel | null>(null);
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    SignupModelHelper.checkLogin().then(async (userId) => {
      if (!userId) {
        document.location = '#/';
      }
    });

    // TagManager.dataLayer(dataLayerHelper.pagina('inicio-ano', 'escolaridade'));
    AmplitudeService.track('Education Begin Date Screen')

    setGraduation(SignupModelHelper.getOngoingGraduation());
  }, [])

  function setEntranceYearMonth(yearMonth: string) {
    const [year] = yearMonth.split('-');
    const startDate = new Date(yearMonth + '-01T12:00');
    const today = new Date();
    today.setHours(12);
    const maxYear = new Date().getFullYear();

    const chat = [...interactions, {
      text: `${months[startDate.getMonth()]} de ${startDate.getFullYear()}`,
      author: InteractionAuthor.CLIENTE
    }];
    setInteractions(chat);

    if (isNaN(+year) || +year < 1900) {
      setTimeout(() => {
        setInteractions([...chat, {
          author: InteractionAuthor.AMARELINHO,
          text: `Informe um ano entre 1900 e ${maxYear}`
        }]);
        setTimeout(() => {
          let chat = document.getElementsByClassName('chat')[0];
          chat.scrollTo(0, chat.scrollHeight);
        }, 500);
      }, 1000)
    } else if (startDate > today) {
      setTimeout(() => {
        const nextMonth = new Date();
        nextMonth.setMonth(nextMonth.getMonth() + 1);
        setInteractions([...chat, {
          author: InteractionAuthor.AMARELINHO,
          text: `Selecione um mês anterior a ${months[nextMonth.getMonth()]} de ${nextMonth.getFullYear()}.`
        }]);
        setTimeout(() => {
          let chat = document.getElementsByClassName('chat')[0];
          chat.scrollTo(0, chat.scrollHeight);
        }, 500);
      }, 1000)

    }
    else { // valid start date
      SignupModelHelper.updateGraduation({ start: startDate });

      if (graduation?.current) {
        const signup = SignupModelHelper.updateGraduation({ saved: true });

        if (signup) {
          setLoading(true)
          AmarelinhoService.saveGraduation(signup).then((ret) => {
            setLoading(false);
            if (!ret.success) {
              setTimeout(() => {
                setInteractions([...chat, {
                  author: InteractionAuthor.AMARELINHO,
                  text: ret.message!
                }]);
                setTimeout(() => {
                  let chat = document.getElementsByClassName('chat')[0];
                  chat.scrollTo(0, chat.scrollHeight);
                }, 500);
              }, 1000)
            } else {
              // TagManager.dataLayer(dataLayerHelper.formEnviado('form_escolaridade'));
              AmplitudeService.track('Education Begin Date Submit')
              SignupModelHelper.update({ graduations: undefined });
              document.location = '#/cursos';
            }
          })
        }

      } else {
        document.location = '#/escolaridade-fim';
      }
    }
  }

  return (
    <>
      <Header step={ 5 } total={ 6 } title="Escolaridade" previous="#/escolaridade-ainda-estuda"></Header>

      <FormYearMonth
        lastAnswer={ graduation?.current === true ? 'Sim, estou cursando.' : 'Não, já terminei.' }
        question="Então, me conta <strong>quando você começou</strong>."
        interactions={ interactions }
        loading={ loading }
        onSubmit={ setEntranceYearMonth }
      />
    </>);
}
